import React, { useEffect, useState } from 'react';

type IconProps = {
  name: string;
  [otherProp: string]: any;
};

function Icon(props: IconProps) {
  const { name, ...restProps } = props;
  const [component, setComponent] = useState<any>(null);

  useEffect(() => {
      import(/* webpackInclude: /\.tsx$/ */ `./${name}Loadable`).then(element => {
        setComponent(element.default);
      });
  }, []);

  return <span>{component && React.cloneElement(component, restProps)}</span>;
}

export default Icon;
